<template>
    <div class="categorymobile">
        <div class="[ align-items-center ] [ ui dropdown ] dropdown-toggle" id="dropdowncategoryM" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="icon-custom-burger-menu big-lg medium color theme ">
                </i>
                <div class="menu main-menu dropdown-menu" aria-labelledby="dropdowncategoryM">
                    <div v-if="$parent.logged" class="pt-4 pb-3">
                            <router-link :to="'/favorite'" class="[ text ] [ text-center d-flex align-items-center pl-3 ] [ color gray-4 ]">
                            <i class="icon-custom-heart big-lg large mr-3"></i> 
                            <span class="ui text tiny-xl mini-md tiny light">{{$t('Favorite')}}</span>
                        </router-link>
                        <router-link  :to="'/profile'" class="[ text ] [ text-center d-flex align-items-center mt-3 pl-3 ] [ color gray-4 ]" >
                            <i class="icon-custom-profile big-lg large mr-3"></i> 
                            <span class="ui text tiny-xl mini-md tiny light mt-1">{{$t('Profile')}}</span>
                        </router-link>
                    </div>
                    <div v-if="$parent.logged" class="divider"></div>
                    <div v-for="(category,i) in categorys" 
                    :key=" 'category'+i "
                    @click="goToRoute($event)"
                    class="item categoryitem"
                    :categoryId="category.id"
                    :name ="category.name">
                        <span class="categoryitem"
                            :categoryId="category.id"
                            :name ="category.name">
                            {{category.name}} {{(category.amount > 0 ? '(' + category.amount + ')' : '')}}
                            <div v-if="category.childrens.length > 0" class="menu">
                                <div @click="goToRoute($event)"
                                    v-for="(subCategory,ii) in category.childrens" :key=" 'subCategory'+ ii " class="item"
                                    :subCategoryId="subCategory.id"
                                    :name ="subCategory.name">
                                    {{subCategory.name}}
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    name: 'categorymobile',
    components: {},
    props:{
        categorys: {
            type: Array,
            default: () => []
        },
        categoryId: Number,
        subCategoryId: Number,
        search: String
    },
    data(){
        return {
        }
    },
    methods: {
        goToRoute(event){
            var path = '/products?'
            this.$parent.search = event.target.getAttribute('name')
            this.$router.push({
                name: 'product', 
                query: {
                    search: this.$parent.search
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>

</style>